import { ActionIcon } from '@mantine/core';
import { IconHeart } from '@tabler/icons-react';
import * as React from 'react';
import { useNavigate } from 'react-router-dom';

import { ROUTES } from 'configs/routes';

type FavoritesButtonProps = {
  className?: string;
  colorIcon?: string;
};

const FavoritesButton: React.FC<FavoritesButtonProps> = ({ className, colorIcon }) => {
  const navigate = useNavigate();

  const handleFavoritesNavigate = React.useCallback(() => {
    navigate(ROUTES.lk.favorites.create());
  }, [navigate]);

  return (
    <ActionIcon
      variant="light"
      size={36}
      className={className}
      aria-label="Избранное"
      onClick={handleFavoritesNavigate}
    >
      <IconHeart size={24} color={colorIcon} />
    </ActionIcon>
  );
};

export default React.memo(FavoritesButton);
